// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Res, setRes, TFunc, UI, uqStringify } from "tonva-react";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { FieldItem, FieldItemInt, FieldItemNum, FieldItemString, FieldItemId } from "tonva-react";
import { CustomerWebsiteLeadsExclude } from "./JkCoupon";

/*--fields--*/
const fields = {
	id: {
		"name": "id",
		"type": "id",
		"isKey": false,
		"label": "Id"
	} as FieldItemId,
	salesman: {
		"name": "salesman",
		"type": "id",
		"isKey": false,
		"label": "Salesman"
	} as FieldItemId,
	startDate: {
		"name": "startDate",
		"isKey": false,
		"label": "StartDate"
	} as undefined,
	excludeDays: {
		"name": "excludeDays",
		"type": "integer",
		"isKey": false,
		"widget": "updown",
		"label": "ExcludeDays"
	} as FieldItemInt,
};
/*==fields==*/

const fieldArr: FieldItem[] = [
	fields.salesman, fields.startDate, fields.excludeDays, 
];

export const ui: UI = {
	label: "CustomerWebsiteLeadsExclude",
	fieldArr,
	fields,
};

const resRaw: Res<any> = {
	$zh: {
	},
	$en: {
	}
};
const res: any = {};
setRes(res, resRaw);

export const t:TFunc = (str:string|JSX.Element): string|JSX.Element => {
	return res[str as string] ?? str;
}

export function render(item: CustomerWebsiteLeadsExclude):JSX.Element {
	return <>{uqStringify(item)}</>;
};
